module.exports = __webpack_public_path__ + "img/Step06.56751cde.webp";